module.exports = __webpack_public_path__ + "img/table-tennis-paddle-ball.0226b915.svg";